// @ngInject
function TimeStampsAdministrationDialog($uibModal, TimeStampingApiService) {

    return {
        showDialog: showDialog,
        showDialogNewDate: showDialogNewDate
    };

    function showDialog(timeStampDayId, locId, userId) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'TimeStampsAdministrationDialogController as vm',
            templateUrl: 'main/timestamp/timeStampsAdministrationDialog/timeStampsAdministrationDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            timeStampDay: function() {
                return TimeStampingApiService.getTimeStampDayById(timeStampDayId);
            },
            locationId: function() {
                return locId;
            },
            user: function() {
                return TimeStampingApiService.getUser(userId);
            }
        };

        return $uibModal.open(modalDefaults).result;
    }

    function showDialogNewDate(newDate, locId, userId) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'TimeStampsAdministrationDialogController as vm',
            templateUrl: 'main/timestamp/timeStampsAdministrationDialog/timeStampsAdministrationDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            timeStampDay: function() {
                return {
                    data: {
                        id: 0,
                        note: "",
                        date: newDate,
                        notify: false,
                        isAccepted: false,
                        userTimeStamps: []
                    }
                };
            },
            locationId: function() {
                return locId;
            },
            user: function() {
                return TimeStampingApiService.getUser(userId);
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function TimeStampsAdministrationDialogController($scope, user, timeStampDay, locationId, TimeStampingApiService, $uibModalInstance) {
    var vm = this;
    var stampsHistoryGrid = {};

    vm.timeStampDay = timeStampDay.data;
    vm.timeStampPairs = [];
    vm.location = {};
    vm.showStampsForAllLocations = false;
    vm.user = user;

    vm.newInStamp = {
        id: 0,
        dateTime: new Date(),
        user: {},
        location: {id: locationId},
        modifyingUser: {},
        timeStampType: { timeStampSystemType: 'In' },
        note: ''
    };
    vm.newOutStamp = {
        id: 0,
        dateTime: new Date(),
        user: {},
        location: {id: locationId},
        modifyingUser: {},
        timeStampType: { timeStampSystemType: 'Out' },
        note: ''
    };

    vm.captureStampsHistoryGrid = captureStampsHistoryGrid;
    vm.createNewTimeStamp = createNewTimeStamp;
    vm.deleteTimeStampPair = deleteTimeStampPair;
    vm.saveTimeStampingDayNote = saveTimeStampingDayNote;

    vm.allowTimeSpanCreation = allowTimeSpanCreation;

    activate();

    function activate() {
        TimeStampingApiService.getLocation(locationId).then(function(response) {
            vm.location = response;
            resetNewTimeStampsTimes();
            constructTimeStampPairs();
        }, function(error) {
            console.log(error);
        });

        $scope.$watch(function() {
            return vm.showStampsForAllLocations;
        }, function() {
            console.log("Watch triggered");
            constructTimeStampPairs();
        });
    }

    function constructTimeStampPairs() {
        vm.timeStampPairs.length = 0;
        vm.timeStampPairs = [];
        var inStamps = _.filter(vm.timeStampDay.userTimeStamps, function(timeStamp) {
            return timeStamp.timeStampType.timeStampSystemType === 'in';
        });

        var outStamps = _.filter(vm.timeStampDay.userTimeStamps, function(timeStamp) {
            return timeStamp.timeStampType.timeStampSystemType === 'out';
        });

        for (var i = 0; i < inStamps.length; i++) {
            var currentInStamp = inStamps[i];

            var currentOutStamp = {dateTime: "--:--:--"};
            if (outStamps.length >= i) { currentOutStamp = outStamps[i]; }
            if (currentOutStamp === undefined) {
                currentOutStamp = {dateTime: "--:--:--"};
            }

            var timeSpan = Math.abs(new Date(currentOutStamp.dateTime) - new Date(currentInStamp.dateTime));

            var timeStampPair = {
                inStamp: currentInStamp,
                outStamp: currentOutStamp,
                span: (timeSpan / 1000 / 60 / 60).toFixed(2)
            };

            if ((vm.showStampsForAllLocations) || (!vm.showStampsForAllLocations && timeStampPair.inStamp.location.id === locationId)) {
                vm.timeStampPairs.push(timeStampPair);
            }
        }

        vm.timeStampPairs = _.sortBy(vm.timeStampPairs, function(pair) {
            return pair.inStamp.dateTime;
        });
    }

    //TODO: Fix this to actually work.
    function roundDateToNearestFiveMinutes(date) {
        console.log("Rounding the following date:");
        console.log(date);
        var coefficient = 1000 * 60 * 5;
        var rounded = new Date(Math.round(date.getTime() / coefficient) * coefficient);
        return date;
    }

    function captureStampsHistoryGrid(s) {
        console.log("Grid captured");
        stampsHistoryGrid = s;
    }

    function createNewTimeStamp() {
        vm.newInStamp.dateTime = new Date(Date.UTC(vm.newInStamp.dateTime.getFullYear(), vm.newInStamp.dateTime.getMonth(),
                                                   vm.newInStamp.dateTime.getDate(), vm.newInStamp.dateTime.getHours(),
                                                   vm.newInStamp.dateTime.getMinutes(), vm.newInStamp.dateTime.getSeconds()));

        vm.newOutStamp.dateTime = new Date(Date.UTC(vm.newOutStamp.dateTime.getFullYear(), vm.newOutStamp.dateTime.getMonth(),
                                                   vm.newOutStamp.dateTime.getDate(), vm.newOutStamp.dateTime.getHours(),
                                                   vm.newOutStamp.dateTime.getMinutes(), vm.newOutStamp.dateTime.getSeconds()));

        vm.timeStampDay.userTimeStamps.push(vm.newInStamp);
        vm.timeStampDay.userTimeStamps.push(vm.newOutStamp);

        if (vm.timeStampDay.id === 0) {
            vm.timeStampDay.user = vm.user;
        }

        $uibModalInstance.startLoadingSpinner();
        TimeStampingApiService.updateTimeStampDay(vm.timeStampDay).then(function(response) {
            console.log("Response");
            console.log(response);

            vm.timeStampDay = response.data;

            constructTimeStampPairs();

            stampsHistoryGrid.refresh();
            stampsHistoryGrid.collectionView.refresh();

            console.log("returning vm.timeStampDay");
            console.log(vm.timeStampDay);
        }, function(error) {
            console.log(error);
        }).finally(function() {
            $uibModalInstance.stopLoadingSpinner();
        });

        resetNewTimeStampsTimes();
    }

    function deleteTimeStampPair(pair) {
        TimeStampingApiService.deleteTimeStamp(pair.inStamp.id).then(function(response) {
            TimeStampingApiService.deleteTimeStamp(pair.outStamp.id).then(function(response) {
                console.log("vm.timeStampPairs (before removal)");
                console.log(vm.timeStampPairs);

                vm.timeStampPairs = _.reject(vm.timeStampPairs, function(p) {
                    return p.inStamp.id === pair.inStamp.id &&
                           p.outStamp.id === pair.outStamp.id;
                });
                vm.timeStampDay.userTimeStamps = _.reject(vm.timeStampDay.userTimeStamps, function(timeStamp) {
                    return timeStamp.id === pair.inStamp.id;
                });
                vm.timeStampDay.userTimeStamps = _.reject(vm.timeStampDay.userTimeStamps, function(timeStamp) {
                    return timeStamp.id === pair.outStamp.id;
                });

                console.log("vm.timeStampPairs (after removal):");
                console.log(vm.timeStampPairs);

                resetNewTimeStampsTimes();
                constructTimeStampPairs();

                stampsHistoryGrid.refresh();
                stampsHistoryGrid.collectionView.refresh();

                console.log("DONE");
            }, function(error) {
                console.log(error);
            });

        }, function(error) {
            console.log(error);
        });
    }

    function saveTimeStampingDayNote() {
        $uibModalInstance.startLoadingSpinner();
        TimeStampingApiService.updateTimeStampDay(vm.timeStampDay).then(function(response) {
            console.log("Note saved. Respose:");
            console.log(response);
        }).finally(function() {
            $uibModalInstance.stopLoadingSpinner();
        });
    }

    function allowTimeSpanCreation() {
        var newInTime = vm.newInStamp.dateTime;
        var newOutTime = vm.newOutStamp.dateTime;

        var isAllowed = true;

        _.forEach(vm.timeStampPairs, function(timeStampPair) {
            var momentNewInTime = moment(newInTime);
            var momentNewOutTime = moment(newOutTime);

            var momentOldInTime = moment(timeStampPair.inStamp.dateTime);
            var momentOldOutTime = moment(timeStampPair.outStamp.dateTime);

            if ((momentNewInTime.isAfter(timeStampPair.inStamp.dateTime) && momentNewInTime.isBefore(timeStampPair.outStamp.dateTime)) ||
                 momentOldInTime.isAfter(newInTime) && momentOldInTime.isBefore(newOutTime)) {
                      isAllowed = false;
                  }

        });

        if (moment(newInTime).isAfter(newOutTime)) {
            isAllowed = false;
        }

        return isAllowed;
    }

    function resetNewTimeStampsTimes() {
        var date = new Date(vm.timeStampDay.date);
        vm.newInStamp.dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
        vm.newOutStamp.dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    }

}

angular
    .module('timestamp.timeStampsAdministration', [])
    .service('TimeStampsAdministrationDialog', TimeStampsAdministrationDialog)
    .controller('TimeStampsAdministrationDialogController', TimeStampsAdministrationDialogController);
